const SERVICE_LOCAL = '31:8081';
const SERVICE_TEST = '242:8088';
const SERVICE_FILE = '242';

const SERVICE_USING = SERVICE_TEST;

exports.vue = {
    devServer: {
        port: '12108',
        open: true,
        proxy: {
            '^(\/(standalonfile|tbfile|upload))': {
                target: `http://192.168.1.${SERVICE_FILE}:20006`,
                changeOrigin: true,
                pathRewrite: {
                    '^/': '/'
                }
            },
            '/hzbtenderagentzero': {
                target: `http://192.168.1.${SERVICE_USING}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/hzbtenderagentzero': '/'
                }
            },
            '/pingbiao': {
                target: `http://192.168.1.${SERVICE_USING}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/hzbtenderagentzero': '/'
                }
            },
            'Zbdl|res|FangAn|file': {
                target: `http://192.168.1.${SERVICE_USING}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/': '/'
                }
            },
        },
    },
    pages: {
        index: {
            entry: './enters/hzb/index.js',
            template: './public/index.html',
            faviconPath: './hzb/favicon.ico',
        },
        zchz: {
            entry: './enters/zchz/index.js',
            template: './public/index.html',
            faviconPath: './zchz/favicon.ico',
        },
    },
}

exports.project = {
    'project-type': 'pc',

    assetsDir: 'static',
    
    ui: {
        element: true,
        mint: false
    },

    router: {
        'base-name': '',
    },

    //ajax类型axios或jquery，用法相同
    ajax: 'jquery',

    sentry: {
        dsn: 'https://7b4c6605f37f4ea89577dfa9587a3368@o367512.ingest.sentry.io/5671082',
        enabled: false
    },

    cnzz: false
}